import { THEMES, THEME_ORDER, type ThemeName } from "../themes";
import styles from "./ThemeSwitcher.module.css";

interface Props {
  current: ThemeName;
  onChange: (n: ThemeName) => void;
}

export function ThemeSwitcher({ current, onChange }: Props) {
  return (
    <div className={styles.wrap}>
      <div className={styles.kicker}>◂ PREVIEW DIRECTION ▸</div>
      <div className={styles.bar}>
        {THEME_ORDER.map((n) => (
          <button
            key={n}
            type="button"
            className={`${styles.btn} ${n === current ? styles.active : ""}`}
            onClick={() => onChange(n)}
          >
            {THEMES[n].label}
          </button>
        ))}
      </div>
    </div>
  );
}
